<template>
  <div id="app" :lang="language">
    <book class="book"
      :data="pages"
      :startPageIndex="1"
      :showPageIndex=false
      :endPageIndex="pages.length - 2"
      :color="color"
      :width=width
      :height=height
      @next="pageChange"
      @prev="pageChange"
      @indexPageChange="indexPageChange"
      @atFirstPage="atFirstPage"
      @atEndPage="atEndPage"
      @swipeLeft="swipeLeft"
      @swipeRight="swipeRight"
      @audioEnded="audioEnded"
    >
      <template slot-scope="prop">
        <img :src="prop.page.url" :alt="prop.page.alt">
        <p>{{ prop.page.title }}</p>
      </template>
    </book>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      // refer https://www.quackit.com/html/html_language_codes.cfm
      // and http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
      language: "ck",
      color: "#01a6a2",
      width: 1536,
      height: 1241,
      pages: [
        {url: 'images/CIM_FIshing_Page_01.jpg', alt: 'opposite front cover'},
        {url: 'images/CIM_FIshing_Page_02.jpg', alt: 'front cover'},
        {url: 'images/CIM_FIshing_Page_03.jpg', alt: 'imprint page', audio: 'audio/Tautai_CIM_region_01.mp3'},
        {url: 'images/CIM_FIshing_Page_04.jpg', alt: 'title page', audio: 'audio/Tautai_CIM_region_01.mp3'},
        {url: 'images/CIM_FIshing_Page_05.jpg', alt: '', audio: 'audio/Tautai_CIM_region_02.mp3'},
        {url: 'images/CIM_FIshing_Page_06.jpg', alt: '', audio: 'audio/Tautai_CIM_region_02.mp3'},
        {url: 'images/CIM_FIshing_Page_07.jpg', alt: '', audio: 'audio/Tautai_CIM_region_03.mp3'},
        {url: 'images/CIM_FIshing_Page_08.jpg', alt: '', audio: 'audio/Tautai_CIM_region_03.mp3'},
        {url: 'images/CIM_FIshing_Page_09.jpg', alt: '', audio: 'audio/Tautai_CIM_region_04.mp3'},
        {url: 'images/CIM_FIshing_Page_10.jpg', alt: '', audio: 'audio/Tautai_CIM_region_04.mp3'},
        {url: 'images/CIM_FIshing_Page_11.jpg', alt: '', audio: 'audio/Tautai_CIM_region_05.mp3'},
        {url: 'images/CIM_FIshing_Page_12.jpg', alt: 'back cover', audio: 'audio/Tautai_CIM_region_05.mp3'}
      ]
    }
  },
  methods: {
    pageChange (curPage, indexPages, pageDatas) {
      // console.log('current page:', curPage,
      //             'Current two index pages:', indexPages,
      //             'The data for the current two index pages:', pageDatas)
    },
    indexPageChange (num) {
      // console.log('Index page changed:', num)
    },
    atFirstPage () {
      // console.log('At first page')
    },
    atEndPage () {
      // console.log('At end page')
    },
    swipeLeft () {
      // console.log('Swiped to the left')
    },
    swipeRight () {
      // console.log('Swiped to the right')
    },
    audioEnded () {
      // console.log('Audio track has completed')
    }
  }
}
</script>

<style scoped>
.book img{
  width: 100%;
  height: 100%
}
.book p{
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 10px
}
</style>



// WEBPACK FOOTER //
// App.vue?186f717d